// extracted by mini-css-extract-plugin
export default {"lazyLoadImage":"oGD9T","loaded":"DSyJ0"};